import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import {
  ClientFileQualityChecklist,
  ClientFileQualityChecklistItem
} from 'app/core/models/client-file-quality-checklist.model';

@Component({
    selector: 'app-client-file-quality-checklist',
    templateUrl: './client-file-quality-checklist.component.html',
    styleUrls: ['./client-file-quality-checklist.component.scss'],
    imports: [NgClass, MatIcon]
})
export class ClientFileQualityChecklistComponent {
  @Input() checklist: ClientFileQualityChecklist;

  // A status the chore never recorded shows as a dash: either the check did not apply, or the chore
  // stopped before reaching it.
  statusLabel(item: ClientFileQualityChecklistItem): string {
    return item.status ? item.status.toUpperCase() : '--';
  }

  // No icon for a status the chore never recorded, which shows as a bare dash.
  statusIcon(item: ClientFileQualityChecklistItem): string {
    switch (item.status) {
      case 'pass':
        return 'check';
      case 'fail':
        return 'close';
      case 'review':
        return 'priority_high';
      default:
        return null;
    }
  }

  statusBadgeClass(item: ClientFileQualityChecklistItem): string {
    switch (item.status) {
      case 'pass':
        return 'bg-success';
      case 'fail':
        return 'bg-danger';
      case 'review':
        return 'bg-warning text-dark';
      default:
        return 'bg-secondary';
    }
  }

  // Items that report a value rather than a verdict show the value in place of a status badge.
  valueLabel(item: ClientFileQualityChecklistItem): string {
    return item.kind === 'percent' ? `${item.value}%` : String(item.value);
  }
}
